import React, { FC, ReactNode } from "react";
import { useMedia } from "react-use";

import { Button } from "@/components/Button";
import { Header } from "@/components/Header";
import { Text } from "@/components/Text";
import { MEDIA_SIZE_SM } from "@/core/media";
import { Flex, Img } from "@/eworkitComponents";

import "./_profile-type-picker-box.scss";

interface IProfileTypePickerBoxProps {
  header: string;
  vatInfo: string;
  renderText: () => ReactNode;
  buttonText: string;
  imgSrc: string;
  onClick: () => void;
}

export const ProfileTypePickerBox: FC<IProfileTypePickerBoxProps> = props => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  const baseClass = "profile-type-picker-box";

  return (
    <Flex className={baseClass} grow={1} padding={["lg"]} direction="column" innerMargin="xl" justify="space-between">
      <Flex direction="column" innerMargin="lg">
        <Img src={props.imgSrc} className={`${baseClass}__img`} />
        <Flex direction="column" innerMargin="lg">
          <Flex direction="column" innerMargin="sm">
            <Header color="black" size="md" weight="bold">
              {props.header}
            </Header>
            <Text color="grey1" size="md">
              {props.vatInfo}
            </Text>
          </Flex>
          <Flex>{props.renderText()}</Flex>
        </Flex>
      </Flex>
      <Flex>
        <Button variant="primary" size="lg" display="block" onClick={props.onClick} testName="create">
          <Text size={isSmallScreen ? "md" : "lg"} whiteSpace="normal">
            {props.buttonText}
          </Text>
        </Button>
      </Flex>
    </Flex>
  );
};
